import type React from 'react';

export const LEFT_INFO_POINT_STYLE: React.CSSProperties = {
    position: 'static',
    marginLeft: 0,
    display: 'flex',
    verticalAlign: 'none',
};

export const RIGHT_INFO_POINT_STYLE: React.CSSProperties = {
    position: 'static',
    marginLeft: 0,
    display: 'flex',
    verticalAlign: 'none',
    flexDirection: 'row-reverse',
};
